// Textos del portal en español neutro con tuteo (DESIGN.md → Tono de voz). Un solo lugar para revisarlos.
export const es = {
  marca: 'Renew MD',
  zona: 'Operación',
  saltar: 'Saltar al contenido',
  navegacionPrincipal: 'Principal',
  nav: { tablero: 'Tablero', empresas: 'Empresas', productos: 'Productos', pedidos: 'Pedidos', configuracion: 'Configuración' },
  cerrarSesion: 'Cerrar sesión',
  acceso: {
    titulo: 'Acceso del equipo',
    intro: 'Ingresa con tu correo y tu contraseña. Si es tu primera vez o la olvidaste, usa «Olvidé mi contraseña».',
    cargando: 'Revisando tu sesión…',
    nuevaTitulo: 'Elige tu contraseña',
    nuevaIntro: 'Escribe la contraseña con la que vas a entrar al portal.',
  },
  mfa: {
    cargando: 'Preparando la verificación…',
    enrolarIntro:
      'Tu cuenta necesita verificación en dos pasos. Escanea este código con una aplicación de autenticación (Google Authenticator, Microsoft Authenticator o similar) y escribe el código de 6 dígitos que muestre.',
    altQr: 'Código QR para vincular tu aplicación de autenticación',
    secretoManual: 'Si no puedes escanear, escribe esta clave en la aplicación:',
    verificarIntro: 'Escribe el código de 6 dígitos de tu aplicación de autenticación.',
    codigo: 'Código de 6 dígitos',
    codigoIncorrecto: 'El código no es válido o venció. Escribe el que muestra tu aplicación ahora.',
    activar: 'Activar y entrar',
    verificar: 'Verificar y entrar',
    verificando: 'Verificando…',
    errorTitulo: 'No pudimos preparar la verificación',
    errorTexto: 'Cierra la sesión y vuelve a entrar. Si el problema sigue, avisa a quien administra el portal.',
  },
  puerta: {
    sinAccesoTitulo: 'Tu cuenta no tiene acceso al portal',
    sinAccesoTexto: 'Pide a quien administra el portal que te dé de alta en el equipo.',
    sinConexionTitulo: 'El portal no está configurado en este entorno',
    sinConexionTexto: 'Falta la dirección o la llave pública de la base de datos.',
    verificando: 'Verificando tu acceso…',
  },
  tablero: {
    titulo: 'Tablero',
    saludo: (nombre: string) => `Hola, ${nombre}.`,
    empresasTitulo: 'Empresas por estado',
    estados: { pendiente: 'En revisión', verificada: 'Verificadas', rechazada: 'Rechazadas', suspendida: 'Suspendidas' },
    verLista: 'Ver lista',
    pedidosTitulo: 'Pedidos',
    pedidosEtiquetas: { pago_en_revision: 'Pagos por conciliar', pagado: 'Por preparar', enviado: 'En camino', pendiente_pago: 'Esperando pago' },
    errorConteo: 'No pudimos contar las empresas. Actualiza la página.',
  },
  empresas: {
    titulo: 'Empresas',
    intro: 'Solicitudes de registro y empresas verificadas.',
    filtros: 'Filtrar por estado',
    todas: 'Todas',
    cargando: 'Cargando empresas…',
    vacio: 'No hay empresas en este estado.',
    error: 'No pudimos cargar las empresas. Actualiza la página.',
    columnas: { empresa: 'Empresa', rfc: 'RFC', tipo: 'Tipo', estado: 'Estado', fecha: 'Alta' },
    tipos: { farmacia: 'Farmacia', clinica: 'Clínica', consultorio: 'Consultorio', distribuidor: 'Distribuidor' },
    estados: { pendiente: 'En revisión', verificada: 'Verificada', rechazada: 'Rechazada', suspendida: 'Suspendida' },
    volver: 'Volver a empresas',
    noExiste: 'Esa empresa no existe o no tienes acceso.',
    datos: 'Datos de la empresa',
    campos: {
      razonSocial: 'Razón social',
      rfc: 'RFC',
      tipo: 'Tipo',
      cp: 'Código postal fiscal',
      correo: 'Correo de facturación',
      telefono: 'Teléfono',
      aviso: 'Aviso de funcionamiento',
      licencia: 'Licencia sanitaria',
      responsable: 'Responsable sanitario',
      cedula: 'Cédula del responsable',
      sinDato: 'Sin dato',
    },
    sucursales: 'Sucursales de entrega',
    sinSucursales: 'Aún no hay sucursales.',
    documentos: 'Documentos',
    sinDocumentos: 'La empresa aún no subió documentos.',
    tiposDocumento: {
      constancia_situacion_fiscal: 'Constancia de situación fiscal',
      aviso_funcionamiento: 'Aviso de funcionamiento',
      licencia_sanitaria: 'Licencia sanitaria',
      cedula_responsable: 'Cédula del responsable sanitario',
      otro: 'Otro documento',
    },
    estadosDocumento: { pendiente: 'En revisión', aceptado: 'Aceptado', rechazado: 'Rechazado' },
    verDocumento: 'Abrir documento',
    aceptar: 'Aceptar',
    rechazarDoc: 'Rechazar',
    notaDocumento: 'Motivo del rechazo',
    notaObligatoria: 'Escribe por qué se rechaza el documento.',
    decision: 'Decisión',
    lista: 'Lista de precios',
    sinListas: 'Aún no hay listas de precios. Crea una para poder verificar empresas.',
    crearLista: 'Crear lista',
    nombreLista: 'Nombre de la lista',
    nombreListaAyuda: 'Por ejemplo «General» o «Distribuidores».',
    verificar: 'Verificar empresa',
    motivo: 'Motivo',
    motivoAyuda: 'La empresa verá este motivo.',
    rechazar: 'Rechazar',
    suspender: 'Suspender',
    mantener: 'Mantén presionado para confirmar',
    hecho: 'Listo',
    avisoVerificada: 'Empresa verificada',
    avisoRechazada: 'Empresa rechazada',
    avisoSuspendida: 'Empresa suspendida',
    avisoDocumento: 'Documento actualizado',
    avisoLista: 'Lista creada',
    errorAccion: 'No pudimos completar la acción. Inténtalo de nuevo.',
    errorTitulo: 'No se pudo completar',
    sinPermiso: 'Tu rol no permite esta acción.',
  },
  productos: {
    titulo: 'Productos',
    intro: 'Catálogo de maquillaje: crea productos, sube su imagen, define presentaciones y precios, y publícalos.',
    nuevo: 'Nuevo producto',
    editar: 'Editar producto',
    cargando: 'Cargando productos…',
    vacio: 'Aún no hay productos. Crea el primero.',
    error: 'No pudimos cargar los productos. Actualiza la página.',
    volver: 'Volver a productos',
    noExiste: 'Ese producto no existe o no tienes acceso.',
    columnas: { producto: 'Producto', categoria: 'Categoría', estado: 'Estado', presentaciones: 'Presentaciones' },
    publicado: 'Publicado',
    borrador: 'Borrador',
    sinCategoria: 'Sin categoría',
    sinImagen: 'Sin imagen',
    campos: {
      nombre: 'Nombre del producto',
      marca: 'Marca',
      categoria: 'Categoría',
      descripcion: 'Descripción',
      ingredientes: 'Ingredientes (opcional)',
      modoDeUso: 'Modo de uso (opcional)',
      iva: 'IVA',
      publicar: 'Publicar en la tienda',
      publicarAyuda: 'Un producto publicado se ve en la tienda. Necesita al menos una presentación con precio público.',
      elegir: 'Sin categoría',
    },
    errores: { nombre: 'Escribe el nombre del producto (mínimo 2 letras).' },
    guardar: 'Guardar producto',
    guardando: 'Guardando…',
    avisoGuardado: 'Producto guardado',
    avisoImagen: 'Imagen subida',
    errorGuardar: 'No pudimos guardar el producto. Inténtalo de nuevo.',
    imagen: 'Imagen del producto',
    imagenAyuda: 'JPG, PNG o WebP de hasta 5 MB. Se recomienda cuadrada.',
    subirImagen: 'Subir imagen',
    cambiarImagen: 'Cambiar imagen',
    subiendo: 'Subiendo…',
    errorTipoImagen: 'La imagen debe ser JPG, PNG o WebP.',
    errorPesoImagen: 'La imagen pesa más de 5 MB.',
    errorSubida: 'No pudimos subir la imagen. Inténtalo de nuevo.',
    guardaPrimero: 'Guarda el producto para poder subir su imagen y agregar presentaciones.',
    presentaciones: 'Presentaciones y precios',
    presentacionesAyuda: 'Una presentación es un tono o un tamaño. El precio público lo ve todo el mundo; las demás listas, solo sus socios.',
    sinPresentaciones: 'Aún no hay presentaciones.',
    sku: 'SKU',
    contenido: 'Tono o tamaño',
    contenidoAyuda: 'Por ejemplo «Tono 120 Nude» o «30 mL».',
    minimo: 'Pedido mínimo',
    multiplo: 'Múltiplo',
    agregar: 'Agregar presentación',
    avisoPresentacion: 'Presentación agregada',
    errorPresentacion: 'No pudimos agregar la presentación. Revisa que el SKU no esté repetido.',
    precio: 'Precio (MXN)',
    precioPublico: 'Público',
    guardarPrecios: 'Guardar precios',
    avisoPrecios: 'Precios guardados',
    errorPrecio: 'Escribe un precio mayor que cero, con hasta dos decimales.',
    activa: 'Activa',
    sinPrecioPublico: 'Esta presentación aún no tiene precio público.',
    ver: 'Ver en la tienda',
  },
  pedidos: {
    titulo: 'Pedidos',
    intro: 'Pagos por conciliar, pedidos por preparar y envíos.',
    filtros: 'Filtrar por estado',
    todos: 'Todos',
    cargando: 'Cargando pedidos…',
    vacio: 'No hay pedidos en este estado.',
    error: 'No pudimos cargar los pedidos. Actualiza la página.',
    volver: 'Volver a pedidos',
    noExiste: 'Ese pedido no existe o no tienes acceso.',
    columnas: { pedido: 'Pedido', cliente: 'Cliente', fecha: 'Fecha', estado: 'Estado', total: 'Total' },
    estados: {
      pendiente_pago: 'Pendiente de pago',
      pago_en_revision: 'Pago en revisión',
      pagado: 'Pagado',
      surtiendo: 'Preparando',
      enviado: 'Enviado',
      entregado: 'Entregado',
      cancelado: 'Cancelado',
    },
    productos: 'Productos',
    entrega: 'Entrega',
    pagos: 'Pagos',
    sinPagos: 'Sin pagos registrados.',
    historial: 'Historial',
    resumen: { subtotal: 'Subtotal', iva: 'IVA', envio: 'Envío', total: 'Total' },
    pagoEstados: { pendiente: 'Pendiente', en_revision: 'En revisión', conciliado: 'Conciliado', rechazado: 'Rechazado', cancelado: 'Cancelado' },
    verComprobante: 'Abrir comprobante',
    sinComprobante: 'Sin comprobante todavía.',
    acciones: 'Acciones',
    aceptarPago: 'Aceptar pago',
    rechazarPago: 'Rechazar pago',
    motivoPago: 'Motivo del rechazo (lo verá la persona)',
    prepararPedido: 'Marcar en preparación',
    enviarPedido: 'Marcar enviado',
    entregarPedido: 'Marcar entregado',
    paqueteria: 'Paquetería',
    guia: 'Guía de rastreo',
    notaOpcional: 'Nota (opcional)',
    cancelarTitulo: 'Cancelar pedido',
    motivoCancelacion: 'Motivo de la cancelación',
    mantener: 'Mantén presionado para cancelar',
    cancelar: 'Cancelar pedido',
    cancelado: 'Cancelado',
    sinPermisoAcciones: 'Tu rol no tiene acciones disponibles en este estado.',
    avisoPago: 'Pago actualizado',
    avisoEstado: 'Pedido actualizado',
    avisoCancelado: 'Pedido cancelado',
    errorAccion: 'No pudimos completar la acción. Inténtalo de nuevo.',
    errorTitulo: 'No se pudo completar',
    notaObligatoria: 'Escribe el motivo.',
  },
  configuracion: {
    titulo: 'Configuración',
    intro: 'Abre o cierra las compras y define a dónde llegan las transferencias. Solo el administrador puede cambiarlo.',
    interruptores: 'Interruptores',
    flags: {
      compras_abiertas: { nombre: 'Compras abiertas', ayuda: 'Permite crear pedidos en la tienda. Apagado, la tienda solo muestra productos.' },
      pago_tarjeta: { nombre: 'Pago con tarjeta', ayuda: 'Requiere una pasarela aprobada. Todavía no está disponible.' },
      mfa_personal: { nombre: 'Verificación en dos pasos del equipo', ayuda: 'Apagado: el equipo entra con usuario y contraseña. Encendido: además exige un código de una aplicación de autenticación.' },
      credito_empresarial: { nombre: 'Crédito empresarial', ayuda: 'Pedidos a crédito para empresas con línea aprobada. Todavía no está disponible.' },
    },
    datosPago: 'Datos de pago (SPEI)',
    ajustes: {
      spei_banco: 'Banco',
      spei_beneficiario: 'Nombre del titular',
      spei_clabe: 'CLABE interbancaria (18 dígitos)',
      envio_costo: 'Costo de envío por pedido (MXN)',
    },
    guardar: 'Guardar datos de pago',
    guardando: 'Guardando…',
    avisoGuardado: 'Datos guardados',
    avisoFlag: 'Interruptor actualizado',
    errorClabe: 'La CLABE debe tener 18 números.',
    errorEnvio: 'El costo de envío debe ser un número mayor o igual que cero.',
    errorGuardar: 'No pudimos guardar. Inténtalo de nuevo.',
    cargando: 'Cargando configuración…',
    error: 'No pudimos cargar la configuración. Actualiza la página.',
  },
  noEncontrada: {
    titulo: 'Esta página no existe',
    texto: 'Revisa la dirección o vuelve al tablero.',
    volver: 'Ir al tablero',
  },
  pie: 'Uso interno del equipo de Renew MD en México.',
} as const
